import type { FaireProductEntity } from "../../entity_types/product";

export const p_znq9je3udq: FaireProductEntity = {
  token: "p_znq9je3udq",
  type: "product",
  name: "PALMIRA - Thong Wedge, Toe Separators",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl: "https://cdn.faire.com/fastly/dc7609b6b87a9e0baec2aa7c74b37225a52a5cf49c9da0e35c51323b8cbb0656.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05279e625e0f8d88483fe5e433cc6e19283bcd142ca155a2d3b4b279a9795c76.jpeg",
    "https://cdn.faire.com/fastly/d987b4906113baa6a9ed9346d25821da0e77dccdb6b128a9096af45fb875f721.jpeg",
    "https://cdn.faire.com/fastly/9d217fc79b237f8f56ab2fb4208bd26ebbcee389221473845b2d6f7ed123970a.jpeg",
    "https://cdn.faire.com/fastly/608e3073d50fc518b014b20063f44a2435d6f7a55056c7c87f05f0dca15a4144.jpeg"
  ],
  priceDollars: 13,
  description: "A sleek thong sandal with an unexpected edge, featuring a sculptural cutout upper that extends into slim toe straps for a statement finish. The low kitten heel keeps the silhouette chic and wearable, while metallic finishes add an extra pop of shine. Available in burgundy, gold, black, and silver.\n\nOOTD\nPair them with a draped mini skirt and fitted tank for a cool night-out look, or style with relaxed trousers and a barely-there top for something more effortless. Finish with a shoulder bag and mixed-metal jewelry.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:11.888Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
